let html = `<div class="extensions__block layer--visible layer--render">
    <div class="extensions__block-head">
        <div class="extensions__block-title">{title}</div>
    </div>
    <div class="extensions__block-body"></div>
</div>`

export default html